import { router } from "@inertiajs/react";
import { Stack, Table, Text } from "@mantine/core";
import type { ReactNode } from "react";
import { getFullName, getYearString } from "../../helpers/stringHelper";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import { occupationTranslations } from "../../models/enums/occupation";
import type { Group } from "../../models/group";
import { groups_path } from "../../routes";

type GroupViewProps = {
  group: Group;
};

export default function GroupView({ group }: GroupViewProps) {
  const { pathWithYearContext } = useYearContext();

  // TODO entscheiden wie die lernenden darstellen
  const apprentices: ReactNode[] = group.apprentices.map((apprentice) => (
    <Stack key={apprentice.id}>
      <Text>{getFullName(apprentice)}</Text>
    </Stack>
  ));

  return (
    <ContentShell title={`Gruppe ${group.name}`} onBack={() => router.get(pathWithYearContext(groups_path))}>
      <Table variant="vertical" layout="fixed" withTableBorder>
        <Table.Tbody>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Td>{group.name}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>Verantwortlicher Coach</Table.Th>
            <Table.Td>{getFullName(group.coach)}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>Jahrgang</Table.Th>
            <Table.Td>{getYearString(group.year_context)}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>Beruf</Table.Th>
            <Table.Td>{occupationTranslations[group.occupation]}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th>Lernende</Table.Th>
            <Table.Td>{group.apprentices.length === 0 ? "Keine Lernende" : apprentices}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </ContentShell>
  );
}
